import * as actionTypes from '../actions/dashboard';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  list: []
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DASHBOARD_SUCCESS: {
      const list = action.payload.map(
        ({ id, name, description, template }) => ({
          id,
          name,
          description,
          cards: template.cards,
          isDefault: template.isDefault
        })
      );
      if (list.length > 0) {
        list.push(
          list.splice(
            list.findIndex(board => board.isDefault),
            1
          )[0]
        );
      }
      return {
        ...state,
        list
      };
    }
    case actionTypes.FETCH_DASHBOARD_FAILURE:
      return {
        ...state
      };
    case actionTypes.UPDATE_DASHBOARD_START: {
      const { id, cards } = action.payload;
      const newList = [...state.list];
      newList.forEach((iterList, index) => {
        if (iterList.id === id) {
          newList[index].cards = cards;
        }
      });
      return {
        ...state,
        list: newList
      };
    }
    case actionTypes.CREATE_DASHBOARD_START: {
      const { description, name, template } = action.payload;
      const tmpList = [...state.list];
      tmpList.push({
        id: uuidv4(),
        description,
        name,
        cards: template.cards,
        isDefault: false,
      });
      return {
        ...state,
        list: tmpList
      };
    }
    default: {
      return state;
    }
  }
};

export default dashboardReducer;
